<template>
    <div class="mediver-login-container">
        <div class="mediver-login-logo">
            <h2 class="main-title">Electroceuticals</h2>
            <div class="sub-title">아이디 찾기</div>
        </div>
        <form class="mediver-login-box" @submit.prevent="findId">
            <input
                v-model="hospitalCode"
                type="text"
                class="login-input"
                placeholder="병원 코드"
                autocomplete="hospitalCode"
            />
            <input
                v-model="name"
                type="text"
                class="login-input"
                placeholder="이름 (실명)"
                autocomplete="name"
            />
            <input
                v-model="phone"
                type="tel"
                class="login-input"
                placeholder="휴대폰 번호"
                autocomplete="tel"
            />
            <button type="submit" class="login-btn">아이디 찾기</button>
            <div v-if="result" class="login-error" style="color:#1976d2;">{{ result }}</div>
            <div class="login-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toResetPassword')">비밀번호 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toRegister')">회원가입</span>
            </div>
        </form>
    </div>
</template>

<script>
import api, {urls} from '@/api'

export default {
    name: 'ID',
    data() {
        return {
            hospitalCode: 'A1000000',
            name: '홍길동',
            phone: '01012341234',
            result: ''
        };
    },
    methods: {
        async findId() {
            if (!this.hospitalCode) {
                alert("병원코드를 입력해주세요.");
                return;
            }
            if (!this.name) {
                alert("이름을 입력해주세요.");
                return;
            }
            if (!this.phone) {
                alert("휴대폰 번호를 입력해주세요.");
                return;
            }
            api.post(urls.login.findID, { hospitalCode: this.hospitalCode,
                name: this.name,
                phone: this.phone })
                .then(response => {
                    const res = response.data;

                    if (res.email) {
                        // 성공 시 아이디 결과를 화면에 표현
                        this.result = `회원님의 아이디는 "${res.email}" 입니다.`;
                    } else {
                        // 실패 시 메시지 표시
                        this.result = res.message || '일치하는 회원정보가 없습니다.';
                    }
                })
                .catch(err => {
                    this.result = '아이디 찾기 중 오류가 발생했습니다.';
                    console.error(err);
                });

        }
    }
};
</script>

